import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_3 = { class: "portSummaryTablesClass" }
const _hoisted_4 = {
  class: "portSummaryClass",
  id: "portfolioOverview"
}
const _hoisted_5 = {
  class: "portSummaryClass",
  id: "assetOverview"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "pe_ntm" }, "P/E (NTM)", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "pe" }, "P/E", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "range" }, "Range", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "return5y" }, "Return5y", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "return3y" }, "Return3y", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "return1y" }, "Return1y", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "returnYTD" }, "ReturnYTD", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "quality" }, "Quality", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", { value: "releaseDate" }, "Release Date", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "kpi" }, "KPI", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "safety" }, "Safety", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "finStrength" }, "Fin. Strength", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "momentum" }, "Momentum", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "sigma" }, "Sigma", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "pe_ntm" }, "P/E (NTM)", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: "pe" }, "P/E", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "range" }, "Range", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "return5y" }, "Return5y", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "return3y" }, "Return3y", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "return1y" }, "Return1y", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "returnYTD" }, "ReturnYTD", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "quality" }, "Quality", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "releaseDate" }, "Release Date", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "kpi" }, "KPI", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "safety" }, "Safety", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "finStrength" }, "Fin. Strength", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("option", { value: "momentum" }, "Momentum", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "sigma" }, "Sigma", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_table_column = _resolveComponent("o-table-column")!
  const _component_o_table = _resolveComponent("o-table")!
  const _component_o_select = _resolveComponent("o-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, "Portfolio Summary: " + _toDisplayString(_ctx.$route.params.hhID), 1),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Loading..."))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_o_table, { data: $setup.combinedPortSummary }, {
          default: _withCtx(() => [
            _createVNode(_component_o_table_column, {
              label: "",
              field: "ProductCustomFieldStrategyGrouping"
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.ProductCustomFieldStrategyGrouping), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "Taxable",
              field: "taxable"
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString($setup.asDollars(props.row.taxable)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "",
              field: "taxablePercent"
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.ProductCustomFieldStrategyGrouping !== "Total"
								? $setup.trim(props.row.taxablePercent * 100, 0) + "%"
								: ""), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "Non-Taxable",
              field: "nonTaxable"
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString($setup.asDollars(props.row.nonTaxable)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "",
              field: "nonTaxablePercent"
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.ProductCustomFieldStrategyGrouping !== "Total"
								? $setup.trim(props.row.nonTaxablePercent * 100, 0) + "%"
								: ""), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_o_table, { data: $setup.favoriteAssets }, {
          default: _withCtx(() => [
            _createVNode(_component_o_table_column, {
              label: "",
              field: "ticker",
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.ticker), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "Taxable",
              field: "totalT",
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.totalT == null ? "-" : $setup.asDollars(props.row.totalT)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "",
              field: "percentT",
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.name !== "Total"
								? props.row.percentT == null
									? "-"
									: $setup.trim(props.row.percentT * 100, 2) + "%"
								: ""), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "Non-Taxable",
              field: "totalNT",
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.totalNT == null ? "-" : $setup.asDollars(props.row.totalNT)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "",
              field: "percentNT",
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.name !== "Total"
								? props.row.percentNT == null
									? "-"
									: $setup.trim(props.row.percentNT * 100, 2) + "%"
								: ""), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "Price",
              field: "price",
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.price == null ? "-" : $setup.asDollars(props.row.price, 2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: "",
              field: "changePercent",
              sortable: ""
            }, {
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString(props.row.name !== "Total"
								? props.row.changePercent == null
									? "-"
									: $setup.trim(props.row.changePercent, 2) + "%"
								: ""), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_o_table_column, {
              label: $setup.optionalFirstColumn,
              field: $setup.optionalFirstColumn,
              sortable: ""
            }, {
              header: _withCtx(() => [
                _createVNode(_component_o_select, {
                  modelValue: $setup.optionalFirstColumn,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.optionalFirstColumn) = $event)),
                  placeholder: "Select a name"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18,
                    _hoisted_19
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString($setup.formatOptionalColumn($setup.optionalFirstColumn, props.row[$setup.optionalFirstColumn])), 1)
              ]),
              _: 1
            }, 8, ["label", "field"]),
            _createVNode(_component_o_table_column, {
              label: $setup.optionalSecondColumn,
              field: $setup.optionalSecondColumn,
              sortable: ""
            }, {
              header: _withCtx(() => [
                _createVNode(_component_o_select, {
                  modelValue: $setup.optionalSecondColumn,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.optionalSecondColumn) = $event)),
                  placeholder: "Select a name"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23,
                    _hoisted_24,
                    _hoisted_25,
                    _hoisted_26,
                    _hoisted_27,
                    _hoisted_28,
                    _hoisted_29,
                    _hoisted_30,
                    _hoisted_31,
                    _hoisted_32,
                    _hoisted_33
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              default: _withCtx((props) => [
                _createTextVNode(_toDisplayString($setup.formatOptionalColumn($setup.optionalSecondColumn, props.row[$setup.optionalSecondColumn])), 1)
              ]),
              _: 1
            }, 8, ["label", "field"])
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ])
  ]))
}